export const getMinMaxPriceHotel = (hotels) => {
    if (!Array.isArray(hotels) || hotels.length === 0) return [0, 1];
    let min = Infinity;
    let max = -Infinity;
    for (let i = 0; i < hotels.length; i++) {
        const hotel = hotels[i];
        const price = +hotel?.minRate?.total;
        if (price < min) {
            min = price;
        }
        if (price > max) {
            max = price;
        }
    }
    if( min === max ) return [min  , max+1]
    return [min, max];
};

export const getRating = ( rating) => {
    switch (rating) {
        case "one" : return 1;
        case "two" : return 2;
        case "three" : return 3;
        case "four" : return 4;
        case "five" : return 5;
        default : return 0;
    }
}

export const childrenAgesOptions = Array.from({ length: 11 }, (_, i) => ({
    value: (i + 1).toString(),
    label: (i + 1).toString(),
}));

export const getRoomsfromRates = (hotel)=>{
    const rooms = []
    Object.keys(hotel.rates).forEach((room) => {
        const guests = room.split("-")[0]
        const adults = Number.parseInt(guests.split(",")[0])
        const children = Number.parseInt(guests.split(",")[1])
        rooms.push({
            adults,
            children
        })
    })

    return rooms
}